module.exports = __webpack_public_path__ + "static/img/error.043c350.png";


//////////////////
// WEBPACK FOOTER
// ./static/error.png
// module id = yO/4
// module chunks = 1